export default __webpack_public_path__ + "static/media/1953.6621c044.png";